import LogoPNG from "../../../assets/images/logo-murray.png"
export const LogoMurray: React.FC = () => {
  return (
    <img src={LogoPNG} alt="" className="w-[80px] h-[85px]" />
  )
}
